import React from "react";
import PropTypes from "prop-types";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import './styles.scss';

interface PhoneInputProps {
  handleInputChange: (value: any, data: any) => void;
  placeholder: string;
  invalid: boolean;
  invalidMsg: string;
  value: string;
  errorClassName: string;
  disabled: boolean;
}

// common component for phone input field
const AccountPhoneInputField = (props: PhoneInputProps) => {
  const {
    handleInputChange,
    placeholder,
    invalid,
    invalidMsg,
    value,
    errorClassName,
    disabled
  } = props;

  return (
    <React.Fragment>
      <div className="d-flex align-items-start w-100 setting-input-box">
        <div className="h-100 w-100">
          <PhoneInput
            inputProps={{
              name: "Phone",
              required: true,
              autoFocus: true,
            }}
            country={"us"}
            value={value}
            onChange={handleInputChange}
            placeholder={placeholder}
            disableCountryCode={false}
            preferredCountries={["us"]}
            countryCodeEditable={true}
            disableDropdown={false}
            dropdownClass="phone-flag-box"
            disabled={disabled}
            inputClass="phone-input"
          />

          {invalid && (
            <span className={errorClassName}>
              <img
                // src={IMG.errorIcon}
                alt=" "
                width="25px"
                height="20px"
                className="cursor-pointer"
              />
            </span>
          )}
          {invalid && <div className="input-error-style">{invalidMsg}</div>}
        </div>
      </div>
    </React.Fragment>
  );
};

AccountPhoneInputField.propTypes = {
  handleInputChange: PropTypes.func,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  invalid: PropTypes.bool,
  invalidMsg: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
};

AccountPhoneInputField.defaultProps = {
  className: undefined,
  placeholder: "",
  invalid: false,
  labelClassName: "page-input-label",
  errorClassName: "field-icon",
};

export default AccountPhoneInputField;
